/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CopyRubricForAutoTestAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['fromAssignmentId', codecNumber, 'from_assignment_id'],
]);
export class CopyRubricForAutoTestAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CopyRubricForAutoTestAssignmentDataParser.decode(input).map(res => new CopyRubricForAutoTestAssignmentData(res));
    }
    static unsafeDecode(input) {
        return CopyRubricForAutoTestAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CopyRubricForAutoTestAssignmentDataParser.encode(data);
    }
    static schema() {
        return CopyRubricForAutoTestAssignmentDataParser.schema();
    }
}
